module.exports = "/packs/images/svg/map-pin~efecf47843087c1db57d7afe49dd48a9.svg";